<template>
  <div>
    <md-card class="md-layout-item md-size-50 md-small-size-100">
      
      <md-card-header>
        <div class="md-title">Modalités de facturation</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout-item">
            <md-field>
              <label for="selectedClient">Client à facturer</label>
              <md-select v-model="selectedClient">
                <md-option v-for="(client, index) in clients" :key="index" :value="client.nom"> {{client.nom}} </md-option>
              </md-select>
            </md-field>
        </div>        
        <div class="md-layout-item">
            <md-field>
              <label for="moyenDePaiment">Moyen de paiment</label>
              <md-select v-model="moyenDePaiment">
                  <md-option value="comptant">Comptant</md-option>
                  <md-option value="30JoursFinDeMois">30 jours fin de mois</md-option>
              </md-select>
            </md-field>
        </div>

        <md-field>
            <label>Délais de paiement</label>
            <md-input v-model="delais"></md-input>
            <span class="md-suffix">jours</span>
        </md-field>

        <md-checkbox v-model="port" class="md-primary">Frais de port</md-checkbox>
        
      </md-card-content>
    
    </md-card>

    <md-card class="md-layout-item md-size-50 md-small-size-100 card-product">
      
      <md-card-header>
        <div class="md-title">Produit(s) a facturer</div>
      </md-card-header>

      <md-card-content>
        <div v-for="(produitForm, indexForm) in produitsForm" v-bind:key="indexForm">
          <br>
          <br>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <span class="md-subheading">Produit {{ indexForm }}</span>
              <md-button class="md-accent" v-if="indexForm > 0" @click="deleteProductForm(index)">Supprimer</md-button>
              <md-field>
                <label for="selectedProduit">Produit à facturer</label>
                <md-select v-model="produitForm.selectedProduit.prix">
                  <md-option v-for="(produit, indexProd) in produits" :key="indexProd" :value="produit.prix"> {{produit.libelle}} </md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item">
                <md-field>
                  <label for="snackbar-duration">Quantité</label>
                  <md-input type="number"></md-input>
                </md-field>
            </div>

            <div class="md-layout-item">
              <md-field>
                  <label>Prix/u</label>
                  <md-input v-model="produitForm.selectedProduit.prix"></md-input>
                  <span class="md-suffix">€</span>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Détail</label>
                <md-textarea v-model="produitForm.selectedProduit.detail" disabled></md-textarea>
              </md-field>
            </div>            
          </div>
        </div>

        <md-button class="md-primary" @click="addNewProductForm">Ajouter un produit</md-button>
        <md-button class="generate">Générer facture</md-button>           
      </md-card-content>
    </md-card>
    
  </div>
</template>

<style scoped>
.md-card.md-theme-default {
  margin-left: auto;
  margin-right: auto;
}

.card-product {
  margin-top: 16px;
}

.generate {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.md-accent {
  position: absolute;
  right: 0;
}
</style>

<script>
import axios from 'axios';

export default {
  name: "FormFacture",
  data: () => ({
    moyenDePaiment: 'comptant',
    delais:'0',
    duration:'1',
    port: false,
    produitsForm: [
      {
        libelle: '',
        quantite: '',
        prix: '',
        selectedProduit: {
          prix: '',
          detail: ''
        }         
      }
    ],
    produits: [
      {
        libelle: '',
        quantite: '',
        prix: '',
      }
    ],
    clients: [
      {
        nom: '',
        adresse: '',
        codePostal: '',
        ville: '',
        remiseCommercial: ''
      }        
    ],
    selectedClient: '',
    index: 0,
    indexForm: 0,
    indexProd: 0
  }),

  created() {
    axios.get(`http://binet-expertise.fr/facturation/server/selectProduits.php`)
    .then(response => {
      this.produits = response.data
    })
    .catch(e => {
      console.log(e)
    })

    axios.get(`http://binet-expertise.fr/facturation/server/selectClients.php`)
    .then(response => {
      this.clients = response.data
    })
    .catch(e => {
      console.log(e)
    })    
  },

  methods: {
    addNewProductForm () {
      this.produitsForm.push({
        libelle: '',
        quantite: '',
        prix: '',
        selectedProduit: {
          prix: '',
          detail: ''
        }        
      })
    },
    deleteProductForm (index) {
        this.produitsForm.splice(index, 1)
    }
  }
};
</script>
